/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "katex/dist/katex.min.css";

const ensureStructuredClone = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (typeof window.structuredClone === "function") {
    return;
  }

  window.structuredClone = (value) => {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return value;
    }
  };
};

export const onServiceWorkerUpdateReady = () => {
  if (typeof window === "undefined") {
    return;
  }
  window.location.reload();
};

export const onClientEntry = () => {
  if (typeof window === "undefined") {
    return;
  }

  ensureStructuredClone();

  const host = window.location.hostname;
  const isLocalhost =
    host === "localhost" || host === "127.0.0.1" || host === "::1";

  if (!isLocalhost || !("serviceWorker" in navigator)) {
    return;
  }

  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister())),
    )
    .catch(() => undefined);
};
